/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit ModalContent.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
overflowY: "auto",
  paddingTop: 'var(--paddingTop)',
paddingBottom: 'var(--paddingBottom)',
paddingLeft: 'var(--paddingLeft)',
paddingRight: 'var(--paddingRight)'})

export default function ModalContent({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  paddingTop= 30,
paddingBottom= 40,
paddingLeft= 50,
paddingRight= 50,
isSelected
}) {
    
    
    
    
    
    

  return (<div
 data-testid="ModalContent.Vertical"
 data-view-path={dataViewPath}
 style={{'--paddingTop': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--paddingBottom': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--paddingLeft': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--paddingRight': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight}}
 className={`views-block ${styles.Vertical}`}
>
{typeof children === 'function'? children({ isSelected: isSelected
}) : null}
</div>)
}